"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import PatientSearch from "@/components/patient/patient-search";
import { Button } from "@/components/ui";
import { Dialog, DialogBody, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { formatName } from "@/lib/format-data";
import { PatientSummary } from "@/types/patient";
interface ChangePatientModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  currentPatientName?: string;
  onConfirm: (patient: PatientSummary) => void;
  isChanging?: boolean;
}
export default function ChangePatientModal(t0) {
  const $ = _c(38);
  const {
    open,
    onOpenChange,
    currentPatientName,
    onConfirm,
    isChanging: t1
  } = t0;
  const isChanging = t1 === undefined ? false : t1;
  const [selectedPatient, setSelectedPatient] = useState();
  const [showConfirmation, setShowConfirmation] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = patient => {
      setSelectedPatient(patient);
      setShowConfirmation(false);
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const handlePatientSelect = t2;
  let t3;
  if ($[1] !== selectedPatient) {
    t3 = () => {
      if (selectedPatient) {
        setShowConfirmation(true);
      }
    };
    $[1] = selectedPatient;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleNext = t3;
  let t4;
  if ($[3] !== onConfirm || $[4] !== selectedPatient) {
    t4 = () => {
      if (selectedPatient) {
        onConfirm(selectedPatient);
      }
    };
    $[3] = onConfirm;
    $[4] = selectedPatient;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleConfirm = t4;
  let t5;
  if ($[6] !== onOpenChange) {
    t5 = newOpen => {
      if (!newOpen) {
        setSelectedPatient(undefined);
        setShowConfirmation(false);
      }
      onOpenChange(newOpen);
    };
    $[6] = onOpenChange;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const handleOpenChange = t5;
  let t6;
  if ($[8] !== selectedPatient) {
    t6 = selectedPatient ? formatName(selectedPatient.firstName, selectedPatient.lastName) : "";
    $[8] = selectedPatient;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const newPatientName = t6;
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <DialogHeader><DialogTitle>Change Patient</DialogTitle></DialogHeader>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== currentPatientName || $[12] !== newPatientName || $[13] !== selectedPatient || $[14] !== showConfirmation) {
    t8 = <DialogBody>{showConfirmation ? <div className="space-y-3"><p className="text-body text-foreground-secondary">Move this attachment from{" "}<span className="font-medium text-foreground">{currentPatientName || "the current patient"}</span>{" "}to{" "}<span className="font-medium text-foreground">{newPatientName}</span>?</p><p className="text-caption text-status-warning-text">This will remove all note links since notes are patient-specific.</p></div> : <div className="space-y-1"><label className="text-body-strong text-foreground">Select new patient</label><PatientSearch patient={selectedPatient} onPatientSelect={handlePatientSelect} placeholder="Search for a patient..." showCreatePatient={false} /></div>}</DialogBody>;
    $[11] = currentPatientName;
    $[12] = newPatientName;
    $[13] = selectedPatient;
    $[14] = showConfirmation;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== handleOpenChange || $[17] !== showConfirmation) {
    t9 = () => showConfirmation ? setShowConfirmation(false) : handleOpenChange(false);
    $[16] = handleOpenChange;
    $[17] = showConfirmation;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const t10 = showConfirmation ? "Back" : "Cancel";
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = <Button variant="secondary" onClick={t9}>{t10}</Button>;
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== handleConfirm || $[23] !== handleNext || $[24] !== isChanging || $[25] !== selectedPatient || $[26] !== showConfirmation) {
    t12 = showConfirmation ? <Button onClick={handleConfirm} disabled={isChanging} isLoading={isChanging}>Confirm Change</Button> : <Button onClick={handleNext} disabled={!selectedPatient}>Next</Button>;
    $[22] = handleConfirm;
    $[23] = handleNext;
    $[24] = isChanging;
    $[25] = selectedPatient;
    $[26] = showConfirmation;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t11 || $[29] !== t12) {
    t13 = <DialogFooter>{t11}{t12}</DialogFooter>;
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t13 || $[32] !== t8) {
    t14 = <DialogContent className="max-w-md">{t7}{t8}{t13}</DialogContent>;
    $[31] = t13;
    $[32] = t8;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== handleOpenChange || $[35] !== open || $[36] !== t14) {
    t15 = <Dialog open={open} onOpenChange={handleOpenChange}>{t14}</Dialog>;
    $[34] = handleOpenChange;
    $[35] = open;
    $[36] = t14;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  return t15;
}